export default {
  app: {
    title: 'RODOSZ'
  },

  pages: {
    index: 'Home'
  },
  menu: {
    logout: 'Logout',
    personalData: 'Personal data',
    dashboard: 'Dashboard',
    userManagement: 'Users'
  },

  label: {
    yes: 'Igen',
    no: 'Nem'
  },

  user: {
    label: {
      name: 'Name',
      username: 'Username',
      email: 'E-mail',
      role: 'Role',
      enabled: 'Enabled',
      userType: 'Type'
    },
    filter: {
      keyword: 'Keyword'
    },
    type: {
      label: 'Type',
      STANDARD: 'Standard',
      GUEST: 'Guest'
    },
    enabled: {
      label: 'Enabled',
      true: 'True',
      false: 'False'
    },
    role: {
      admin: 'Admin'
    },
    details: {
      title: 'User data',
      name: 'Name',
      username: 'Username',
      email: 'E-mail',
      enabled: 'Enabled',
      type: 'Type',
      role: 'Role'
    },
    notification: {
      deleteSuccess: 'User is successfully  deleted',
      deleteError: 'Error while delete user',
      userSuccess: 'User data is successfully saved',
      userError: 'Error while save user data',
      activationUserSuccess: 'User is successfully activated',
      activationUserError: 'Error while activate user',
      inactivationUserSuccess: 'User is successfully inactivated',
      inactivationUserError: 'Error while inactivate user'
    }
  },
  form: {
    validator: {
      required: {
        invalidMessage: 'Field is required'
      },
      email: {
        invalidMessage: 'Not valid email type'
      },
      length: {
        invalidMessage: 'Not valid length'
      }
    }
  },

  button: {
    add_new: 'Add new',
    activate: 'Activate',
    inactivate: 'Inactivate',
    activation_email: 'Send activation email',
    edit: 'Edit',
    open: 'Open',
    delete: 'Delete',
    save: 'Save',
    finalize: 'Finalize',
    back: 'Back',
    cancel: 'Cancel',
    submit: 'Submit',
    approve: 'Approve',
    deny: 'Deny',
    summary: 'Summary'
  },

  filter: {
    search: 'Search'
  },

  dashboard: {
    greeting: 'Welcome'
  },

  pst: {
    161210: 'Orvos-C Költségtérítéses',
    162210: 'Fogorvos-C Költségtérítéses',
    163210: 'Gyógyszerész-C Költségtérítéses',
    160003: 'Licenc díj',
    164280: 'Pszichológus-C KK foglalkoztatott'
  }
};
